import React from 'react';

const KIND_LABEL = {
  evento: 'Evento',
  tarea: 'Tarea',
  armado: 'Armado',
  desarmado: 'Desarmado',
};

const MONTHS = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'];

// La fecha llega como 'YYYY-MM-DD' del backend. Se parte a mano en vez de
// pasarla por `new Date`, que la interpreta como UTC y en un huso negativo
// muestra el día anterior.
function splitDate(iso) {
  if (!iso) return null;
  const [y, m, d] = iso.split('-').map(Number);
  return { day: String(d).padStart(2, '0'), month: MONTHS[m - 1], year: String(y).slice(2) };
}

// El texto coincidente se resalta sin acentos ni mayúsculas de por medio: se
// normaliza una copia para ubicar el tramo y se corta el string original, así
// lo que se muestra conserva las tildes que el usuario no escribió.
function highlight(text, query) {
  const raw = text || '';
  const q = (query || '').trim();
  if (!q) return raw;
  const fold = s => s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  const at = fold(raw).indexOf(fold(q));
  if (at < 0) return raw;
  return (
    <>
      {raw.slice(0, at)}
      <mark className="ag-sr-mark">{raw.slice(at, at + q.length)}</mark>
      {raw.slice(at + q.length)}
    </>
  );
}

function subtitle(row) {
  const parts = [];
  if (row.kind !== 'evento' && row.event_name) parts.push(row.event_name);
  if (row.place) parts.push(row.place);
  if (row.client) parts.push(row.client);
  if (row.odoo_code) parts.push(row.odoo_code);
  return parts;
}

function Row({ row, query, onOpen }) {
  const date = splitDate(row.date);
  const parts = subtitle(row);
  return (
    <button type="button" className={`ag-sr-row ag-sr-row--${row.kind}`} onClick={() => onOpen(row)}>
      <span className="ag-sr-date">
        {date ? (
          <>
            <span className="ag-sr-day">{date.day}</span>
            <span className="ag-sr-month">{date.month} {date.year}</span>
          </>
        ) : <span className="ag-sr-month">sin fecha</span>}
      </span>
      <span className="ag-sr-body">
        <span className="ag-sr-title">{highlight(row.title, query)}</span>
        {parts.length > 0 && (
          <span className="ag-sr-sub">{parts.map((p, i) => (
            <React.Fragment key={i}>{i > 0 && <span className="ag-sr-dot"> · </span>}{highlight(p, query)}</React.Fragment>
          ))}</span>
        )}
      </span>
      <span className={`ag-sr-kind ag-sr-kind--${row.kind}`}>{KIND_LABEL[row.kind] || row.kind}</span>
    </button>
  );
}

export default function AgendaSearchResults({
  query, results, total, loading, loadingMore, error, hasMore, onLoadMore, onOpen,
}) {
  if (loading) return <div className="ag-spinner-wrap"><div className="spinner" /></div>;
  if (error) return <div className="ag-sr-empty">{error}</div>;
  if (results.length === 0) {
    return (
      <div className="ag-sr-empty">
        Sin resultados para <strong>{query.trim()}</strong>.
        <div className="ag-sr-empty-hint">Probá con otra palabra o sumá categorías arriba.</div>
      </div>
    );
  }

  const today = new Date();
  const todayIso = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
  const upcoming = results.filter(r => r.date && r.date >= todayIso);
  const past = results.filter(r => !r.date || r.date < todayIso);

  return (
    <div className="ag-sr">
      <div className="ag-sr-count">{total} {total === 1 ? 'resultado' : 'resultados'}</div>

      {upcoming.length > 0 && <div className="ag-sr-group">Próximos</div>}
      {upcoming.map(r => <Row key={`${r.kind}-${r.id}`} row={r} query={query} onOpen={onOpen} />)}

      {past.length > 0 && <div className="ag-sr-group">Pasados</div>}
      {past.map(r => <Row key={`${r.kind}-${r.id}`} row={r} query={query} onOpen={onOpen} />)}

      {hasMore && (
        <div className="ag-sr-more">
          <button type="button" className="btn btn-ghost ag-btn" onClick={onLoadMore} disabled={loadingMore}>
            {loadingMore ? 'Cargando…' : `Cargar más (${total - results.length} restantes)`}
          </button>
        </div>
      )}
    </div>
  );
}
